const LEGACY_DONT_ASK_KEY = "dontAskAgain";

export const useDontAskAgain = (property: string) => {
  // One-time migration: old code stored this flag under the bare "dontAskAgain" key.
  if (
    !localStorage.getItem(property) &&
    localStorage.getItem(LEGACY_DONT_ASK_KEY) === "true"
  ) {
    localStorage.setItem(property, "true");
    localStorage.removeItem(LEGACY_DONT_ASK_KEY);
  }

  const dontAskAgain = localStorage.getItem(property) === "true";
  const setDontAskAgain = (value: boolean) => {
    localStorage.setItem(property, value.toString());
  };

  return { dontAskAgain, setDontAskAgain };
};
